import React from "react";
import { Sun, Zap, Home, Gauge } from "lucide-react";
import { useTranslation } from "@/context/LanguageContext";

const ICONS = [Sun, Zap, Home, Gauge];
const COLORS = [
  "bg-yellow-100 text-yellow-700",
  "bg-green-100 text-green-700",
  "bg-emerald-100 text-emerald-700",
  "bg-lime-100 text-lime-700",
];

export default function HowItWorks() {
  const { t } = useTranslation();
  const steps = t("how.steps");
  const kpis = t("how.kpis");
  return (
    <section
      id="how"
      data-testid="how-it-works"
      className="relative py-20 md:py-28 bg-white border-t border-stone-200"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="max-w-2xl">
          <span className="text-green-700 font-semibold tracking-widest text-xs uppercase">
            {t("how.eyebrow")}
          </span>
          <h2 className="mt-3 font-display font-extrabold text-4xl lg:text-5xl text-stone-900">
            {t("how.title_pre")}{" "}
            <span className="text-green-700">{t("how.title_hl")}</span>{" "}
            {t("how.title_mid")}
          </h2>
          <p className="mt-4 text-stone-600 leading-relaxed">
            {t("how.subtitle")}
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <div
                key={i}
                data-testid={`how-step-${i + 1}`}
                className="relative rounded-3xl border border-stone-200 bg-white p-6 hover:shadow-xl hover:-translate-y-1 transition"
              >
                <div className="absolute -top-4 left-6 font-handwritten text-5xl text-green-600/80">
                  {i + 1}
                </div>
                <div className={`w-14 h-14 rounded-2xl grid place-items-center ${COLORS[i]} mb-5 mt-2`}>
                  <Icon className="w-7 h-7" strokeWidth={2.2} />
                </div>
                <h3 className="font-display font-bold text-lg text-stone-900">
                  {s.title}
                </h3>
                <p className="mt-2 text-sm text-stone-600 leading-relaxed">
                  {s.desc}
                </p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-4">
          {kpis.map((x) => (
            <div key={x.k} className="rounded-2xl bg-green-50 border border-green-100 p-5">
              <div className="digit-stat font-display font-extrabold text-3xl text-green-800">
                {x.k}
              </div>
              <p className="mt-2 text-sm text-stone-700">{x.v}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
